export default "__VITE_ASSET__70e6f53f__"